<template>
	<el-form ref="form" :model="form" label-width="80px">
		<el-form-item label="姓名" prop="name" :rules="[{required: true, message: '姓名不能为空', trigger: 'blur'}]">
			<el-input v-model="form.name" prop="form.name" placeholder="请输入联系人姓名"></el-input>
		</el-form-item>
		<el-form-item label="身份证" prop="id_card"
			:rules="[{min:10,max:20,required: true, message: '身份证格式不正确', trigger: 'blur'}]">
			<el-input v-model="form.id_card" placeholder="请输入身份证"></el-input>
		</el-form-item>
		<el-form-item label="卡号" prop="account"
			:rules="[{min:10,max:20,required: true, message: '卡号格式不正确', trigger: 'blur'}]">
			<el-input v-model="form.account" placeholder="请输入卡号"></el-input>
		</el-form-item>
		<el-form-item label="银行" prop="bank" :rules="[{required: true, message: '请输入银行', trigger: 'blur'}]">
			<el-input v-model="form.bank" placeholder="请输入银行"></el-input>
		</el-form-item>
	</el-form>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					id: 0,
					name: "",
					id_card: "",
					account: "",
					bank: "",
				}
			};
		},

		methods: {
			init(memberBank) {
				if (memberBank != undefined) {
					this.form = memberBank;
				}
			},

			yes(close) {
				if (this.form.name === "") {
					V.alertError("姓名不能为空", 2000);
					return;
				}
				if (this.form.id_card == "" || this.form.id_card.length < 10 || this.form.id_card.length > 20) {
					V.alertError("身份证格式有误", 2000);
					return;
				}
				if (this.form.account == "" || this.form.account.length < 10 || this.form.account.length > 20) {
					V.alertError("卡号格式有误", 2000);
					return;
				}
				
				console.log("银行信息",this.form);
				return;

				if (this.form.id == 0) {
					this.$api.member
						.addBank(this.form)
						.then((res) => {
							if (res.Status == 1) {
								this.alert("提交成功", 2000);
								this.$emit("ok");
								close();
							} else {
								this.alertError(res.Data, 2000);
							}
						})
						.catch((r) => {});
				} else {
					this.$api.member
						.modifyBank(this.form)
						.then((res) => {
							if (res.Status == 1) {
								this.alert("提交成功", 2000);
								this.$emit("ok");
								close();
							} else {
								this.alertError(res.Data, 2000);
							}
						})
						.catch((r) => {});
				}

			},
		},
	};
</script>
